import { createRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { Box, Button, Tooltip } from '@mui/material'
import { Stack } from '@mui/system'
import { ParentSize } from '@visx/responsive'
import ImagePicker from 'packages/ui/ImagePicker'
import ActionButtons from '../ActionButtons'

const ImageStep = ({image, loading, onSubmit, onGoBack}) => {
  const { t } = useTranslation()
  const { setValue, formState } = useFormContext()
  const [uploadedFile, setUploadedFile] = useState(image)
  const dropzoneRef = createRef()
  const hasError = Boolean(formState.errors.picture)
  const handleOpenDialog = () => {
    if (dropzoneRef.current) {
      dropzoneRef.current.open()
    }
  }

  const reset = () => {
    setUploadedFile(null)
  }

  const handlePictureChange = async (dataB64, rawFile) => {
    let pictureData = null

    if (dataB64) {
      pictureData = {
        name: rawFile?.name ?? 'N/A',
        dataURL: dataB64
      }
    }
    setValue('image', pictureData)
    setUploadedFile(pictureData)
  }

  return (
    <Stack minWidth="600px" alignItems="center" justifyContent="space-between" height="100%" gap={2} pb={2}>
      <ParentSize>
        {({ height }) => (
          <Box sx={{ height: '100%', maxHeight: height, overflowY: 'auto' }}>
            <Box flex={1} width={'100%'} height={'100%'}>
              {uploadedFile ? (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  <img
                    src={uploadedFile.dataURL}
                    alt="advertisements_picture"
                    style={{ borderRadius: '8px', maxHeight: '500px' }}
                  />
                </Box>
              ) : (
                <ImagePicker
                  ref={dropzoneRef}
                  name="picture"
                  picture={uploadedFile}
                  onPictureChange={handlePictureChange}
                />
              )}
            </Box>
          </Box>
        )}
      </ParentSize>
      <Stack direction="row" justifyContent="space-between" width="100%">
        <Stack direction="row" gap={1}>
          {
            !uploadedFile && (
              <Tooltip title={t('advertisements.edition.content.picture.tooltip.import')}>
                <Button
                  onClick={handleOpenDialog}
                  variant="outlined"
                  sx={{ maxWidth: '40px', minHeight: '32px', height: '32px' }}>
                  <i style={{ fontSize: '16px' }} className="fa-regular fa-cloud-arrow-up"></i>
                </Button>
              </Tooltip>
            )
          }
          <Tooltip title={t('advertisements.edition.content.picture.tooltip.delete')}>
            <Button onClick={reset} variant="outlined" sx={{ maxWidth: '40px', minHeight: '32px', height: '32px' }}>
              <i style={{ fontSize: '16px' }} className="fa-regular fa-trash"></i>
            </Button>
          </Tooltip>
        </Stack>
      </Stack>
      <ActionButtons
        loading={loading}
        onGoBack={onGoBack}
        onSubmit={onSubmit}
        disabled={hasError}
        labelSubmit={t('ui_elements.form_next')}
      />
    </Stack>
  )
}

export default ImageStep
